import { 
  getText, 
  appendText 
} from '../../../assets/js/text-renderer';

import '../shared/landing-styles.scss';
import './landing-collector.scss';
import '../../shared/landing-hero.scss';
import '../../shared/cta-hero';
import '../../shared/dynamic-tabs/dynamic-tabs.js';
import '../../shared/feature-card/featured-card.js';

export const loadText = async (mainLandingEl, ctaButtons) => {
  const data = await getText('platform/intelek-collector/intelek-collector-landing');
  const content = data.stories[0].content;

  setHeroContent(content, ctaButtons, mainLandingEl);
  setWhyContent(content, mainLandingEl);
  setHowContent(content, mainLandingEl);
  setFeaturesContent(content, mainLandingEl);
  setPricingContent(content, mainLandingEl);
  await setExtraContent(mainLandingEl);
};

function setHeroContent(content, ctaButtons, mainLandingEl) {
  appendText(content.promotion_alert, 'promotion-alert', mainLandingEl);
  appendText(content.hero_title, 'hero-title', mainLandingEl);
  appendText(content.hero_description, 'hero-description', mainLandingEl);
  appendText(ctaButtons.start_trial_btn, 'hero-cta-trial-button', mainLandingEl);
  appendText(ctaButtons.book_demo_btn, 'hero-cta-demo-button', mainLandingEl);
};

function setWhyContent(content, mainLandingEl) {
  appendText(content.benefits_title, 'benefits-title', mainLandingEl);
  appendText(content.benefits_items[0].text, 'benefits-item-0', mainLandingEl);
  appendText(content.benefits_items[1].text, 'benefits-item-1', mainLandingEl);
  appendText(content.benefits_items[2].text, 'benefits-item-2', mainLandingEl);
  appendText(content.benefits_items[3].text, 'benefits-item-3', mainLandingEl);
  appendText(content.benefits_items[4].text, 'benefits-item-4', mainLandingEl);
  appendText(content.benefits_items[5].text, 'benefits-item-5', mainLandingEl);
};

function setHowContent(content, mainLandingEl) {
  appendText(content.workflow_title, 'workflow-title', mainLandingEl);
  appendText(content.workflow_items[0].title, 'destinos-tab', mainLandingEl);
  appendText(content.workflow_items[0].description, 'destinos-text', mainLandingEl);
  appendText(content.workflow_items[1].title, 'fuentes-tab', mainLandingEl);
  appendText(content.workflow_items[1].description, 'fuentes-text', mainLandingEl);
  appendText(content.workflow_items[2].title, 'sync-tab', mainLandingEl);
  appendText(content.workflow_items[2].description, 'sync-text', mainLandingEl);
  appendText(content.workflow_items[3].title, 'monitoring-tab', mainLandingEl);
  appendText(content.workflow_items[3].description, 'monitoring-text', mainLandingEl);
};

function setFeaturesContent(content, mainLandingEl) {
  appendText(content.features_title, 'features-title', mainLandingEl);
  appendText(content.features_items[0].text, 'features-items-0', mainLandingEl);
  appendText(content.features_items[1].text, 'features-items-1', mainLandingEl);
  appendText(content.features_items[2].text, 'features-items-2', mainLandingEl);
  appendText(content.features_items[3].text, 'features-items-3', mainLandingEl);
  appendText(content.features_items[4].text, 'features-items-4', mainLandingEl);
  appendText(content.features_items[5].text, 'features-items-5', mainLandingEl);
  appendText(content.features_items[6].text, 'features-items-6', mainLandingEl);
  appendText(content.features_items[7].text, 'features-items-7', mainLandingEl);
  appendText(content.features_items[8].text, 'features-items-8', mainLandingEl);
};

function setPricingContent(content, mainLandingEl) {
  appendText(content.plan_card_text, 'plan-card-text', mainLandingEl);
  appendText(content.plan_card_cta, 'plan-card-cta', mainLandingEl);
};

async function setExtraContent(mainLandingEl) {
  const otherModulesContent = await getText('platform/shared/other-modules');
  const otherModules = otherModulesContent.stories[0].content;

  appendText(otherModules.more_modules_title, 'more-modules-title', mainLandingEl);
  appendText(otherModules.more_modules_content[0].richtext, 'more-modules-item-0', mainLandingEl);
  appendText(otherModules.more_modules_content[0].text, 'more-modules-cta-0', mainLandingEl);
  appendText(otherModules.more_modules_content[1].richtext, 'more-modules-item-1', mainLandingEl);
  appendText(otherModules.more_modules_content[1].text, 'more-modules-cta-1', mainLandingEl);
  appendText(otherModules.more_modules_content[2].richtext, 'more-modules-item-2', mainLandingEl);
  appendText(otherModules.more_modules_content[2].text, 'more-modules-cta-2', mainLandingEl);
};